import { ChakraProvider, Box } from '@chakra-ui/react';
import { Routes, Route } from 'react-router-dom';
import ArticlePage from '../ArticlePage/ArticlePage';
import Footer from '../../components/Footer/Footer';
import HomePage from '../HomePage/HomePage';
import NavBar from '../../components/NavBar/NavBar';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import MemifyPage from '../MemifyPage/MemifyPage';
import MyCareerPage from '../MyCareerPage/MyCareerPage';
import MyWorkPage from '../MyWorkPage/MyWorkPage';
import ReadingPage from '../ReadingPage/ReadingPage';
import ReadingPageV2 from '../ReadingPageV2/ReadingPageV2';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import reading24 from '../../constants/reading24';
import reading25 from '../../constants/reading25';
import reading26 from '../../constants/reading26';
import theme from '../../theme';
import './App.css';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <ScrollToTop />
      <Box minHeight="100vh" display="flex" flexDirection="column">
        <NavBar />
        <Box flex="1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/memify" element={<MemifyPage />} />
            <Route path="/career" element={<MyCareerPage />} />
            <Route path="/work" element={<MyWorkPage />} />
            <Route path="/reading2024" element={<ReadingPage props={reading24} />} />
            <Route path="/reading2025" element={<ReadingPage props={reading25} />} />
            <Route path="/reading2026" element={<ReadingPageV2 props={reading26} />} />
            <Route path="/deep-dives/:slug" element={<ArticlePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Box>
        <Footer />
      </Box>
    </ChakraProvider>
  );
}

export default App;
